import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import {
  usePersonalizationClasses,
  getErrorMessage,
} from "../hooks/usePersonalizationQueries";

interface ClassSelectorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
}

export const ClassSelector: React.FC<ClassSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  error,
}) => {
  const {
    data: classes = [],
    isLoading,
    isError,
    error: queryError,
  } = usePersonalizationClasses();

  const hasError = isError || Boolean(error);
  const errorMessage = error || (isError ? getErrorMessage(queryError) : null);

  return (
    <div className="space-y-2">
      <Select
        value={value}
        onValueChange={onChange}
        disabled={disabled || isLoading}
      >
        <SelectTrigger
          className={`input-auth relative flex items-center justify-between ${
            hasError ? "border-red-300 focus:ring-red-300" : ""
          }`}
        >
          <SelectValue
            placeholder={
              isLoading
                ? "Loading classes..."
                : isError
                  ? "Failed to load classes"
                  : "Class"
            }
            className="text-white/60"
          />
        </SelectTrigger>

        <SelectContent className="bg-white/95 backdrop-blur-sm border border-white/30 rounded-[6px]">
          {classes.map((cls) => (
            <SelectItem
              key={cls.id}
              value={cls.id}
              className="cursor-pointer font-inter text-[17px] font-normal leading-[22px] tracking-normal text-white"
            >
              {cls.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {errorMessage && <p className="text-red-200 text-sm">{errorMessage}</p>}
    </div>
  );
};
